import { render, staticRenderFns } from "./PublicLayout.vue?vue&type=template&id=74f43c84&scoped=true"
import script from "./PublicLayout.vue?vue&type=script&lang=js"
export * from "./PublicLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f43c84",
  null
  
)

export default component.exports